import { ICrmField } from '@/features/dataSourceEdit/types';
import { FC } from 'react';
import { CheckInstallationMessage } from './CheckInstallationMessage';
import { useTranslation } from 'react-i18next';
import { CheckInstallationList } from './CheckInstallationList';

type CheckInstallationFieldsListProps = {
  listItems: ICrmField[];
};

export const CheckInstallationFieldsList: FC<CheckInstallationFieldsListProps> = ({ listItems }) => {
  const { t } = useTranslation('data_source_edit');

  return (
    <CheckInstallationList listItems={listItems} empyListMessage={t('crm.check_installation.no_fields')}>
      {listItems.map((param) => (
        <CheckInstallationMessage key={param.fieldId} asListItem>
          {param.name} {param.description ? `(${param.description})` : ''}
        </CheckInstallationMessage>
      ))}
    </CheckInstallationList>
  );
};
